import { Tooltip } from '@mui/material';
import { ReactElement } from 'react';

interface Props {
  children: ReactElement;
}

export function EstimatedQtyTooltip({ children }: Props) {
  return (
    <Tooltip
      title={
        <p style={{ fontSize: '1rem' }}>
          Once you populate the physical count. We will estimate the qty
          available for next week. Estimate is computed by subtracting away what
          is still due this week and next week from the physical count. <br />
          <br />
          For example, if you had a physical count of 250 for this week and the
          system reported 100 ordered, 20 already shipped before physical count
          was entered, and 40 due next week. The estimated qty for next week
          would be{' '}
          <em style={{ color: 'salmon' }}>
            <b>250 - (100-20) - 40 = 130</b>
          </em>{' '}
        </p>
      }
      arrow
    >
      {children}
    </Tooltip>
  );
}

export function NewQtyTooltip({ children }: Props) {
  return (
    <Tooltip
      title={
        <p style={{ fontSize: '1rem' }}>
          The value you enter here will automatically overwrite the qty
          available for the product or variant. <br />
          <br />
          For example, if the system shows a current qty of 100 and you enter 55
          as the new qty, the system will be updated to have 55. <br />
          <br />
          <em style={{ color: 'salmon' }}>
            <b>
              Note: If you delete the value shown here, the current qty in the
              system will still show what you had entered here.
            </b>
          </em>{' '}
        </p>
      }
      arrow
    >
      {children}
    </Tooltip>
  );
}

export function AlreadyShippedTotalTooltip({ children }: Props) {
  return (
    <Tooltip
      title={
        <p style={{ fontSize: '1rem' }}>
          The total qty that have already been shipped out for what was ordred
          this week. Does not matter if it was shipped before or after the
          physical count was entered.
          <br />
          <br />
          When orders for this week are marked as shipped on the orders page,
          all of the items they contain will count towards this already shipped
          number.
        </p>
      }
      arrow
    >
      {children}
    </Tooltip>
  );
}

export function AlreadyShippedBeforePhysicalCountTooltip({ children }: Props) {
  return (
    <Tooltip
      title={
        <p style={{ fontSize: '1rem' }}>
          The qty for what was ordered this week that was shipped before the
          physical count was entered.
          <br />
          <br />
          Since these orders were shipped before the physical count was entered,
          we can assume that the products were not included in the physical
          count because they were already on the truck.
          <br />
          <br />
          This number is used to help you determine how many of this week's
          orders still need to be deducted from the amount you physically
          counted when computing the estimated qty.
          <br />
          <br />
          For example, if you counted 100 and saw that 80 were ordered this week
          with 15 shipped before the physical count was entered. Then the number
          still needed to deduct from the physical count for this week would be
          65 (80-15).
        </p>
      }
      arrow
    >
      {children}
    </Tooltip>
  );
}

export function AlreadyShippedAfterPhysicalCountTooltip({ children }: Props) {
  return (
    <Tooltip
      title={
        <p style={{ fontSize: '1rem' }}>
          The qty for what was ordered this week that was shipped after the
          physical count was entered.
          <br />
          <br />
          Since these orders were shipped after the physical count was entered,
          we can assume that the products were included in the physical count
          because they hadded been shipped yet.
          <br />
          <br />
          This number is only shown to add context to total orders shipped this
          week. It is not used to compute the estimated qty.
        </p>
      }
      arrow
    >
      {children}
    </Tooltip>
  );
}
